import {
  BpkLargeSpinner,
  SPINNER_TYPES,
} from '@skyscanner/backpack-web/bpk-component-spinner';

import type { Maybe } from '@shared/types/utils';

import STYLES from './CenteredSpinner.module.scss';

type Props = {
  className?: Maybe<string>;
};

const CenteredSpinner = ({ className }: Props) => {
  const classes = [STYLES.CenteredSpinner];
  if (className) {
    classes.push(className);
  }
  return (
    <div className={classes.join(' ')}>
      <BpkLargeSpinner type={SPINNER_TYPES.primary} />
    </div>
  );
};

export default CenteredSpinner;
